import { useSearchParams } from "react-router-dom";

export interface SearchParams {
  [key: string]: string;
}

type UpdateSearchParamsOptions = {
  replace?: boolean;
};

const useCustomSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getSearchParams = (): SearchParams => {
    const params: SearchParams = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  const updateSearchParam = (key: string, value: string): void => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(key, value);
    setSearchParams(newParams, { replace: true });
  };

  const updateSearchParams = (
    newParams: SearchParams,
    options?: UpdateSearchParamsOptions,
  ): void => {
    const updatedParams = new URLSearchParams();
    for (const key in newParams) {
      if (
        newParams[key] !== undefined &&
        newParams[key] !== "" &&
        newParams[key] !== "0"
      ) {
        updatedParams.set(key, newParams[key] as string);
      }
    }
    setSearchParams(updatedParams, { replace: options?.replace ?? false });
  };

  const removeSearchParam = (key: string): void => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams, { replace: true });
  };

  return {
    getSearchParams,
    updateSearchParam,
    updateSearchParams,
    removeSearchParam,
  };
};

export default useCustomSearchParams;
